<template>
  <div id="beforeAfterTwo"></div>
</template>

<script>
export default {
  name: "BeforeAfterTwo",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        beforeLabel: "Before",
        beforeValue: "12 hours",
        afterLabel: "After",
        afterValue: "30 minutes",
        context: "Time to complete monthly reports",
        chip: "Results",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("beforeAfterTwo");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const valueSize = exporting ? 72 : 72 * this.scale;
      const labelSize = exporting ? 24 : 24 * this.scale;
      const contextSize = exporting ? 30 : 30 * this.scale;
      const logoHeight = exporting ? 40 : 40 * this.scale;
      const chipSize = exporting ? 20 : 20 * this.scale;
      const arrowSize = exporting ? 50 : 50 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.light || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#10a37f";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background: linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 25%, #16213e 50%, #1a1a2e 75%, #0f0f0f 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Gradient orb effect -->
          <div style="
            position: absolute;
            top: -20%;
            right: -20%;
            width: 60%;
            height: 60%;
            background: radial-gradient(circle, ${primaryColor}25 0%, transparent 70%);
            pointer-events: none;
          "></div>
          <div style="
            position: absolute;
            bottom: -30%;
            left: -20%;
            width: 70%;
            height: 70%;
            background: radial-gradient(circle, #6366f130 0%, transparent 60%);
            pointer-events: none;
          "></div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" style="opacity: 0.9;" />
          </div>

          <!-- Before/After content -->
          <div style="padding: 0 8%; position: relative; z-index: 1; flex: 1; display: flex; flex-direction: column; justify-content: center;">
            <div style="
              font-size: ${contextSize}px;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.7);
              line-height: 1.4;
              margin-bottom: 48px;
              text-align: center;
            ">${this.data.context}</div>

            <div style="display: flex; align-items: center; justify-content: center; gap: 48px;">
              <!-- Before -->
              <div style="text-align: center;">
                <div style="
                  font-size: ${labelSize}px;
                  font-weight: 500;
                  color: rgba(255, 255, 255, 0.5);
                  margin-bottom: 12px;
                  text-transform: uppercase;
                  letter-spacing: 0.1em;
                ">${this.data.beforeLabel}</div>
                <div style="
                  font-size: ${valueSize}px;
                  font-weight: 700;
                  color: rgba(255, 255, 255, 0.4);
                  line-height: 1;
                  text-decoration: line-through;
                  text-decoration-color: #ef4444;
                ">${this.data.beforeValue}</div>
              </div>

              <!-- Arrow -->
              <div style="
                font-size: ${arrowSize}px;
                background: linear-gradient(135deg, ${primaryColor} 0%, #6366f1 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
              ">→</div>

              <!-- After -->
              <div style="text-align: center;">
                <div style="
                  font-size: ${labelSize}px;
                  font-weight: 500;
                  color: ${primaryColor};
                  margin-bottom: 12px;
                  text-transform: uppercase;
                  letter-spacing: 0.1em;
                ">${this.data.afterLabel}</div>
                <div style="
                  font-size: ${valueSize}px;
                  font-weight: 700;
                  background: linear-gradient(135deg, #ffffff 0%, ${primaryColor} 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  background-clip: text;
                  line-height: 1;
                ">${this.data.afterValue}</div>
              </div>
            </div>
          </div>

          <!-- Footer with chip -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <div style="display: flex; justify-content: center;">
              <span
                style="
                  display: inline-block;
                  background: rgba(255, 255, 255, 0.1);
                  backdrop-filter: blur(10px);
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 10px 24px;
                  letter-spacing: 0.05em;
                  text-transform: uppercase;
                  border: 1px solid rgba(255, 255, 255, 0.15);
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
